{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://www.w3.org/ns/pub-schema/manifest/module/url.schema.json",
  "title": "URL",
  "type": "string",
  "format": "uri-reference"
}
